export default {
  bottomRow: {
    display: 'flex',
    rowGap: '1rem',
    whiteSpace: 'nowrap',
    columnGap: '2rem',
    width: '100%',
    backgroundColor: 'bg.main',
    border: '1px solid',
    borderColor: 'border.lighter',
    p: '.8rem 1rem'
  }
};
